import React, { useEffect, useRef, useState } from 'react';
import './UnifiedTesterPlayer.css';

const UnifiedTesterPlayer = ({ url, title, poster, autoPlay = true }) => {
    const videoRef = useRef(null);
    const [isHlsLoaded, setIsHlsLoaded] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        // Dynamically load HLS.js from CDN
        if (window.Hls) {
            setIsHlsLoaded(true);
            return;
        }

        const script = document.createElement('script');
        script.src = "https://cdn.jsdelivr.net/npm/hls.js@latest";
        script.async = true;
        script.onload = () => setIsHlsLoaded(true);
        script.onerror = () => setError("Failed to load video engine (HLS.js)");
        document.body.appendChild(script);

        return () => {
            // Cleanup if needed? Usually scripts stay in body.
        };
    }, []);

    useEffect(() => {
        if (!isHlsLoaded || !videoRef.current || !url) return;

        const video = videoRef.current;

        if (window.Hls.isSupported()) {
            const hls = new window.Hls();
            hls.loadSource(url);
            hls.attachMedia(video);
            hls.on(window.Hls.Events.MANIFEST_PARSED, () => {
                if (autoPlay) video.play().catch(e => console.log("Autoplay blocked", e));
            });
            hls.on(window.Hls.Events.ERROR, (event, data) => {
                console.error("HLS Error:", data);
                if (data.fatal) setError("Fatal playback error: " + data.type);
            });

            return () => hls.destroy();
        } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
            // Safari native HLS support
            video.src = url;
            video.addEventListener('loadedmetadata', () => {
                if (autoPlay) video.play().catch(e => console.log("Autoplay blocked", e));
            });
        } else {
            setError("HLS is not supported in this browser.");
        }
    }, [isHlsLoaded, url, autoPlay]);

    if (error) {
        return (
            <div className="unified-player-error">
                <i className="bi bi-exclamation-triangle-fill mb-2 fs-2"></i>
                <p>{error}</p>
            </div>
        );
    }

    return (
        <div className="unified-tester-container">
            <div className="unified-player-overlay">
                <div className="player-badge">LIVE SSAI</div>
                {title && <div className="player-title">{title}</div>}
            </div>
            <video 
                ref={videoRef} 
                className="unified-video-element"
                poster={poster}
                controls
                playsInline
            />
        </div>
    );
};

export default UnifiedTesterPlayer;
